import axios, { AxiosResponse } from "axios";
import React, { useEffect, useState, useContext } from "react";
import { config } from "../../contexts/UrlContext";
import { toast } from "react-toastify";
import { Dimmer, Loader, Button, Popup, Checkbox, Grid, Segment ,Dropdown} from 'semantic-ui-react';
import { IGrid, IGridField, ITableActions } from "../Interfaces/TableInterface";
import { IField } from "../Interfaces/AdminInterface";
import ContentManagerSearcher from "../ContentManager/ContentManagerSearcher";
import CMDropdownOptions from "../ContentManager/CMDropdownOptions";
import MetaListBox from "./MetaListBox";
import OrderMetaListBox from "./OrderMetaListBox";
import { FieldContext } from "../../contexts/FieldsContext";
import ThemeDropdown from "../Theme/ThemeDropdown";
import history from "../../History";
import { stringIsEmpty , objectIsNull} from "../../utils/stringUtils";

import { SettingsContext } from "../../contexts/SettingsContext";
import ErrorPage from "../ErrorPage/ErrorPage";
import AuthContext from "../../contexts/AuthContext";
import { getRequest, postRequest } from "../../services/axiosService";


export const orderOptions = [
    { key: 0, text: 'Ascending', value: "asc" },
    { key: 1, text: 'Descending', value: "des" },
]

export const actionOptions = [
    { key: 5, text: 'None', value: 5 },
    { key: 0, text: 'View Record', value: 0 },
    { key: 1, text: 'Edit Record', value: 1 },
    { key: 2, text: 'Download Record', value: 2 },
    { key: 3, text: 'Download PDF Rendition', value: 3 },
    { key: 4, text: 'Display PDF Rendition', value: 4 },
]


function GridSettings() {

    const recsPerPage = 25;
    const columTotal = 12;
    const defaultLoadingMessage = "Loading Table Settings";

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let tableId: string = params.get('id')!;

    const { auth } = useContext(AuthContext);


    const [loading, setLoading] = useState<boolean>(true);
    const [disableSave, setDisableSave] = useState<boolean>(false);

    //Table Settings
    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [saveSearchSelected, setSaveSearchSelected] = useState<boolean>(false);
    const [savedSearch, setSavedSearch] = useState<IField>();
    const [cmQuerySelected, setCMQuerySelected] = useState<boolean>(false);
    const [cmQuery, setCMQuery] = useState<string>("");
    const [containerSelected, setContainerSelected] = useState<boolean>(false);
    const [container, setContainer] = useState<IField>();
    const [filters, setFilters] = useState<string>("");
    const [fields, setFields] = useState<IGridField[]>([]);
    const [selectedTheme, setSelectedTheme] = useState<string>("Default");
    const [customSizing, setCustomSizing] = useState<boolean>(false);

    //Options
    const [cacheTableData, setCacheTableData] = useState<boolean>(false);
    const [displayLogo, setDisplayLogo] = useState<boolean>(false);
    const [displayIcons, setDisplayIcons] = useState<boolean>(false);
    const [displayFileIcons, setDisplayFileIcons] = useState<boolean>(false);
    const [sortTableData, setSortTableData] = useState<boolean>(false);
    const [sortField, setSortField] = useState<IField>();
    const [sortOrder, setSortOrder] = useState<string>("");
    const [displayElectronic, setDisplayElectronic] = useState<boolean>(false);
    const [restrictSearch, setRestrictSearch] = useState<boolean>(false);
    const [restrictionField, setRestrictionField] = useState<string>("");
    const [recordsPerPageSelected, setRecordsPerPageSelected] = useState<boolean>(false);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(recsPerPage);
    const [downloadDocument, setDownloadDocument] = useState<boolean>(false);
    const [pdfRendition, setPDFRendition] = useState<boolean>(false);
    const [viewPdfRendition, setViewPDFRendition] = useState<boolean>(false);
    const [latestVersionOnly, setLatestVersionOnly] = useState<boolean>(false);
    const [latestFinalVersionOnly, setLatestFinalVersionOnly] = useState<boolean>(false);
    const [disableTitle, setDisableTitle] = useState<boolean>(false);
    const [disableSearch, setDisableSearch] = useState<boolean>(false);
    const [viewDocument, setViewDocument] = useState<boolean>(false);
    const [editDocument, setEditDocument] = useState<boolean>(false);
    const [wordWrap, setWordWrap] = useState<boolean>(false);
    const [tableAction, setTableAction] = useState<number>(2); //Download

    //iFrame Preview
    const [displayPreview, setDisplayPreview] = useState<boolean>(false);
    const [iFrameSrc, setIFrameSrc] = useState<string>("");

    const [loadingMessage, setLoadingMessage] = useState<string>(defaultLoadingMessage);


    const { hasAdminPrivileges } = useContext(SettingsContext);

    useEffect(() => {
        async function getData() {
            if (tableId !== null) {
                await getTableSettings();
                await getTable();
            }
            setLoading(false);
        }
        getData();
    }, []);

    const getTableSettings = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Admin/GetTableSettings`);
            let settings = response.data;
            if (settings.restrictionField !== null) {
                setRestrictionField(settings.restrictionField.name);
            }
            else {
                setRestrictionField("");
            }
         
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve Settings`);
        }
    }

  
    const getTable = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Grid/GetGrid?id=${tableId}`);

            let data = response.data;
                setName(data.name);
                setDescription(data.description);

                if (data.savedSearch){
                    setSavedSearch(data.savedSearch);
                    setSaveSearchSelected(true);
                }
                
                if (data.cmQuery) {
                    setCMQuery(data.cmQuery);
                    setCMQuerySelected(true);
                }

                if (data.container) {
                    setContainer(data.container);
                    setContainerSelected(true);
                }
               
                setFilters(data.filters)
                setFields(data.fields);
                setCustomSizing(data.customSizing);
                setSelectedTheme(data.selectedTheme);
                setDisplayIcons(data.displayIcons);
                setDisplayFileIcons(data.displayFileIcons);

                if (data.sortOrder !== null && data.sortOrder !== "") {
                    setSortTableData(true);
                    setSortField(data.sortField);
                    setSortOrder(data.sortOrder);
                } else {
                    setSortTableData(false);
                }
               
                setDisplayElectronic(data.displayElectronic);
                setRestrictSearch(data.restrictSearch);

                if (data.recordsPerPage !== recsPerPage) {
                    setRecordsPerPage(data.recordsPerPage);
                    setRecordsPerPageSelected(true);
                }

                setCacheTableData(data.cacheTableData);
                setDisplayLogo(data.displayLogo);
                setDownloadDocument(data.downloadDocument);
                setPDFRendition(data.pdfRendition);
                setViewPDFRendition(data.viewPDFRendition);
                setLatestVersionOnly(data.latestVersionOnly);
                setLatestFinalVersionOnly(data.latestFinalVersionOnly);
                setDisableTitle(data.disableTitle);
                setDisableSearch(data.disableSearch);
                setViewDocument(data.viewDocument);
                setEditDocument(data.editDocument);
                setWordWrap(data.wordWrap);
                setTableAction(data.defaultTableAction);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to get table`);
        }      
    }

    const handleBlur = (e: any) => {
        if (e.currentTarget.value === '0') e.currentTarget.value = '1'
    }
    const handleKeypress = (e: any) => {
        const characterCode = e.key
        if (characterCode === 'Backspace') return

        const characterNumber = Number(characterCode)
        if (characterNumber >= 0 && characterNumber <= 9) {
            if (e.currentTarget.value && e.currentTarget.value.length) {
                return
            } else if (characterNumber === 0) {
                e.preventDefault()
            }
        } else {
            e.preventDefault()
        }
    }

    //Table Criteria on Change
    const onContainerSelectionChange = () => {
        setContainerSelected(!containerSelected);

        if (!containerSelected === true){
            setSaveSearchSelected(false);
            setSavedSearch(undefined);
            setCMQuerySelected(false);
            setCMQuery("");
        }
    }

    const onSavedSearchSelectionChange = () => {
        setSaveSearchSelected(!saveSearchSelected);

        if (!saveSearchSelected === true) {
            setContainerSelected(false);
            setContainer(undefined);
            setCMQuerySelected(false);
            setCMQuery("");
        }
    }

    const onCMSearchSelectionChange = () => {
        setCMQuerySelected(!cmQuerySelected);

        if (!cmQuerySelected === true) {
            setContainerSelected(false);
            setContainer(undefined);
            setSaveSearchSelected(false);
            setSavedSearch(undefined);
        }
    }

   //Table Options Change
    const onDisplayRecIconChange = () => {
        setDisplayIcons(!displayIcons);

        if (!displayIcons === true) {
            setDisplayFileIcons(false);
        }
    }

    const onDisplayFileIconChange = () => {
        setDisplayFileIcons(!displayFileIcons);

        if (!displayFileIcons === true) {
            setDisplayIcons(false);
        }
    }

    //Latest Versions
    const onLatestVersionChange = () => {
        setLatestVersionOnly(!latestVersionOnly);

        if (!latestVersionOnly === true) {
            setLatestFinalVersionOnly(false);
        }
    }

    const onLatestFinalVersionChange = () => {
        setLatestFinalVersionOnly(!latestFinalVersionOnly);

        if (!latestFinalVersionOnly === true) {
            setLatestVersionOnly(false);
        }
    }

    const onSortOrderChange = () => {
        setSortTableData(!sortTableData);

        if (!sortTableData === false){
            setSortField(undefined);
            setSortOrder("");
        }
    }

    const onThemeChange = (e: any) => {
        setSelectedTheme(e);
    }
    const onOrderChange = (e: any, data: any) => {
        setSortOrder(data.value);
    }

    const onActionChange = (e: any, data: any) => {
        setTableAction(data.value);
    }

    const saveSettings = async () => {
        setDisableSave(true);
        setDisplayPreview(false);
        setIFrameSrc("");

        //verify settings are valid
        if (stringIsEmpty(name)) {
            toast.error("Name cannot be empty");
            setDisableSave(false);
            return;
        }

        if (stringIsEmpty(description)) {
            toast.error("Description cannot be empty");
            setDisableSave(false);
            return;
        }

        if (!saveSearchSelected && !cmQuerySelected && !containerSelected) {
            toast.error("Please select a record search criteria option");
            setDisableSave(false);
            return;
        }

        if (saveSearchSelected && objectIsNull(savedSearch)) {
            toast.error("Saved Search Criteria cannot be empty");
            setDisableSave(false);
            return;
        }

        if (cmQuerySelected && (stringIsEmpty(cmQuery))) {
            toast.error("Content Manager Search Criteria cannot be empty");
            setDisableSave(false);
            return;
        }

        if (containerSelected && objectIsNull(container)) {
            toast.error("Container Search Criteria cannot be empty");
            setDisableSave(false);
            return;
        }

        if (fields.length === 0) {
            toast.error("At least 1 table column must be selected");
            setDisableSave(false);
            return;
        }

        if (customSizing) {
            //Check if all columns have a width set to total of 12
            let totalWidth = 0;
            fields.forEach((field: IGridField) => {
                if (field.colWidth > 0) {
                    totalWidth = field.colWidth + totalWidth;
                }
            });
            if (totalWidth !== columTotal) {
                toast.error(`Custom column widths must equal ${columTotal}`);
                setDisableSave(false);
                return;
            }
        }

        if (sortTableData) {
            if (stringIsEmpty(sortOrder)) {
                toast.error("Order to Sort cannot be left blank");
                setDisableSave(false);
                return;
            }

            if (objectIsNull(sortField )) {
                toast.error("Sort by Field cannot be left blank");
                setDisableSave(false);
                return;
            }
        }

        if (recordsPerPageSelected) {
            if (recordsPerPage === 0 || recordsPerPage > 500) {
                toast.error("Record per page must be a value between 1 - 500");
                setDisableSave(false);
                return;
            }
        }

        let newSettings : IGrid = {
            id: tableId === null? "": tableId,
            templateName: "",
            shortDescription: "",
            shortName:"",
            name: name,
            description: description,
            savedSearch: savedSearch,
            cmQuery: cmQuery,
            container: container,
            filters: filters,
            customSizing: customSizing,
            fields: fields,
            selectedTheme: selectedTheme, 
            displayIcons: displayIcons,
            displayFileIcons: displayFileIcons,
            sortTableData: sortTableData,
            sortField: sortField,
            sortOrder: sortOrder,
            displayElectronic: displayElectronic,
            restrictSearch: restrictSearch,
            recordsPerPage: recordsPerPage,
            downloadDocument: downloadDocument,
            pdfRendition: pdfRendition,
            viewPdfRendition: viewPdfRendition,
            latestVersionOnly: latestVersionOnly,
            latestFinalVersionOnly: latestFinalVersionOnly,
            displayLogo: displayLogo,
            disableSearch: disableSearch,
            disableTitle: disableTitle,
            viewDocument: viewDocument,
            editDocument: editDocument,
            wordWrap: wordWrap,
            checkedOutTo: "",
            lastUpdatedBy: "",
            lastUpdatedDate: "",
            cacheTableData: cacheTableData,
            defaultTableAction: tableAction,
            lastCachedDate: ""
        };


        try {
            let response: AxiosResponse = await postRequest(auth, `/Grid/SaveTable`, newSettings);

            toast.success("Table successfully saved");
            
            //display iframe on save if not selected to be cached 
            if (!cacheTableData) {
                setDisplayPreview(true);
                setIFrameSrc(`${config.baseUrl}/Grid?id=${response.data.id}`);
            }

            if (tableId === "" || tableId === null) {
                //go back to homepage 
                history.push("/CM2WebShare");
            }
            setDisableSave(false);

        } catch (error) {
            console.log(error);
            toast.error(`Unable to save table. See log for more info`);
            setDisableSave(false);
            return;
        }
    }

    const onRecordsPerPageChange = () =>
    {
        setRecordsPerPageSelected(!recordsPerPageSelected);

        if (!recordsPerPageSelected === false) {
            setRecordsPerPage(recsPerPage); //set back to default records per page
        }
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>{loadingMessage }...</Loader>
            </Dimmer>
        );
    }

    else if (hasAdminPrivileges) {
        return (
            <div className="ui container" style={{ borderBottom: "0", maxWidth: "95%", marginTop: 10, paddingBottom: 20 }} id="home">
                <div className="header blue headerStyleBlue">Configure Table</div>
                <div className="header gray headerStyleGray">TABLE NAME</div>
                <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                    <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Table Name" id="table-name" value={name} onChange={(e) => { setName(e.target.value) }} />
                </div>
                <div className="header gray headerStyleGray">TABLE DESCRIPTION</div>
                <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                    <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Table Description" id="table-description" value={description} onChange={(e) => { setDescription(e.target.value) }} />
                </div>
                <div className="header gray headerStyleGray" style={{ marginTop: 10 }}>TABLE RECORD CRITERIA</div>
                <div style={{ marginLeft: 10 }}>
                    <div style={{ marginTop: 10, marginLeft: 10 }}><Checkbox toggle label='Container' onChange={onContainerSelectionChange} checked={containerSelected} style={{ marginRight: 10 }} /></div>
                    <div style={{ marginTop: 10, marginLeft: 10 }}><Checkbox toggle label='Saved Search' onChange={onSavedSearchSelectionChange} checked={saveSearchSelected} style={{ marginRight: 10 }} /></div>
                    <div style={{ marginTop: 10, marginLeft: 10 , marginBottom: 10}}><Checkbox toggle label='Content Manager Search' onChange={onCMSearchSelectionChange} checked={cmQuerySelected} style={{ marginRight: 10 }} /></div>

                    {containerSelected && (
                        <ContentManagerSearcher canClear={true} id="containerRecord" name="containerRecord" endpoint="RecordSearch" currentValue={container}
                            placeHolder="Search Folder (Container)..." callback={(e: any) => setContainer(e)} additionalOptions={`&isContainerSearch=${true}`}
                            type="container" fieldInfo={null}
                        />
                    )}
                    {saveSearchSelected && (
                        <ContentManagerSearcher canClear={true} id="savedSearch" name="savedSearch" endpoint="SavedSearch" currentValue={savedSearch}
                            placeHolder="Enter Saved Search..." callback={(e: any) => setSavedSearch(e)} additionalOptions={null} type="savedSearch" fieldInfo={null}
                        />
                    )}
                    {cmQuerySelected && (
                        <div className="ui input fluid" >
                            <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Content Manager Query" id="cmQuery" value={cmQuery} onChange={(e) => { setCMQuery(e.target.value) }} />
                        </div>
                    )}
                </div>
                <Grid style={{ marginLeft: 10 }}>
                    <Grid.Row>
                        <FieldContext.Provider
                            value={{
                                fields: fields,
                                setFields: setFields,
                                customSizing: customSizing,
                                setCustomSizing: setCustomSizing,
                                columnTotalWidth: columTotal
                            }}>
                            <Grid.Column width={8}>
                                <MetaListBox id="rec-meta-flds" title="TABLE COLUMNS" subtitle="Select the metadata (properties) that will display as the table columns in your CM2WebShare table display." />
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <OrderMetaListBox id="rec-meta-list" title="DISPLAYED TABLE COLUMNS" subtitle="Modify the selected fields below"
                                    showTableCol={true} />
                            </Grid.Column>
                        </FieldContext.Provider>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Column width={8}>
                        <Segment>
                            <div className="header blue headerStyleBlue">Table Settings</div>
                            <div className="meta" style={{ marginLeft: 10 }}>Adjust additional settings for the table</div>

                            <div className="header gray headerStyleGray" >DISPLAY</div>
                            <div style={{ marginTop: 10, marginLeft: 10 }}><Checkbox toggle  label='Display Logo' onChange={() => setDisplayLogo(!displayLogo)} checked={displayLogo} /> </div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Display Record Type Icons' onChange={onDisplayRecIconChange} checked={displayIcons} /> </div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}> <Checkbox toggle  label='Display File Type Icons' onChange={onDisplayFileIconChange} checked={displayFileIcons} /> </div>
                            <div style={{ marginTop: 10, marginLeft: 10 }}><Checkbox toggle  label='Word Wrap Table Data' onChange={() => setWordWrap(!wordWrap)} checked={wordWrap} /> </div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Custom Amount of Records per Page' onChange={onRecordsPerPageChange} checked={recordsPerPageSelected} /></div>
                            {recordsPerPageSelected && (
                                <>
                                    <div className="header gray headerStyleGray" >RECORDS PER PAGE</div>
                                    <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                                        <Popup trigger={<input type="number" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Amount of Records Per Page" id="tablesPerPage" onKeyDown={handleKeypress} onBlur={handleBlur} value={recordsPerPage} min={1} max={500} onChange={(e) => { setRecordsPerPage(e.target.valueAsNumber) }} />}
                                            content="Load time is dependent on page capacity set. Larger page capacity will require a longer load time. Maximum records per page is 500"></Popup>
                                    </div>
                                </>
                            )}
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Disable Title' onChange={() => setDisableTitle(!disableTitle)} checked={disableTitle} /></div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Disable Search' onChange={() => setDisableSearch(!disableSearch)} checked={disableSearch} /></div>

                            <div className="header gray headerStyleGray" >CACHE TABLE</div>
                            <div style={{ marginTop: 10, marginLeft: 10 }}>
                                <Popup content="Table results will be cached for a period of time. This will prevent the display live table results" trigger={
                                    <Checkbox toggle label='Cache Table Results' onChange={() => setCacheTableData(!cacheTableData)} checked={cacheTableData} />
                                }/>
                            </div>

                            <div className="header gray headerStyleGray" >SORT/FILTER</div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}>
                                <Checkbox toggle label='Default Sort Order' onChange={onSortOrderChange} checked={sortTableData} />
                                {sortTableData && (
                                    <>
                                        <div className="header gray headerStyleGray" >SORT BY FIELD</div>
                                        <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                                            <CMDropdownOptions key="contactId" callback={(e: any) => setSortField(e)} currentValue={sortField} endpoint="GetAllSortFields" name="sortField" placeHolder="Enter Field" />
                                        </div>
                                        <div className="header gray headerStyleGray" style={{ marginLeft: '10px' }}>ORDER TO SORT</div>
                                        <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                                            <Dropdown className="bgGrey" fluid id="search-dropdown" placeholder='Search' style={{ backgroundColor: "#e5e5e5", marginBottom: 10 }} search selection options={orderOptions} onChange={onOrderChange} value={sortOrder} />
                                        </div>
                                    </>
                                )}
                            </div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Latest Version Only' onChange={onLatestVersionChange} checked={latestVersionOnly} /></div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Latest Final Version Only' onChange={onLatestFinalVersionChange} checked={latestFinalVersionOnly} /></div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Electronic Records Only' onChange={() => setDisplayElectronic(!displayElectronic)} checked={displayElectronic} /></div>

                            {(restrictionField !== null && restrictionField !== "") && (
                                <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label={`${restrictionField} Records Only`} onChange={() => setRestrictSearch(!restrictSearch)} checked={restrictSearch} /></div>
                            )}
                            

                            <div className="header gray headerStyleGray" >ACTIONS</div>
                            <div style={{ marginTop: 5, marginLeft:10}}><Checkbox toggle label='Download Documents' onChange={() => setDownloadDocument(!downloadDocument)} checked={downloadDocument} /></div>
                            <div style={{ marginTop: 5, marginLeft:10}}><Checkbox toggle label='View Documents' onChange={() => setViewDocument(!viewDocument)} checked={viewDocument} /></div>
                            <div style={{ marginTop: 5, marginLeft:10}}><Checkbox toggle label='Edit Documents' onChange={() => setEditDocument(!editDocument)} checked={editDocument} /></div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Download PDF Rendition' onChange={() => setPDFRendition(!pdfRendition)} checked={pdfRendition} /></div>
                            <div style={{ marginTop: 5, marginLeft: 10 }}><Checkbox toggle label='Display PDF Rendition' onChange={() => setViewPDFRendition(!viewPdfRendition)} checked={viewPdfRendition} /></div>

                            <div className="header gray headerStyleGray" style={{ marginLeft: '10px' }}>DEFAULT ACTION</div>
                            <div className="meta" style={{marginLeft:10}}>The action applied when clicking on a table row</div>
                            <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                                <Dropdown className="bgGrey" fluid id="action-dropdown" placeholder='Select Table Action' style={{ backgroundColor: "#e5e5e5", marginBottom: 10 }} search selection options={actionOptions} onChange={onActionChange} value={tableAction} />
                            </div>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Segment>
                            <div className="header blue headerStyleBlue">Theme</div>
                            <div className="meta" style={{ marginLeft: 10 }}>Customise the table appearance</div>
                            <ThemeDropdown selectedTheme={selectedTheme} onThemeChange={onThemeChange} key="theme" />
                        </Segment>
                    </Grid.Column>
                </Grid>

                <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                    <Button id="table-save" style={{ marginTop: 10, marginBottom: 10 }} disabled={disableSave} onClick={saveSettings}>Save</Button>
                    <Button id="table-cancel" style={{ marginTop: 10, marginLeft: 5, marginBottom: 10 }} onClick={getTable}>Cancel</Button>
                </div>

                {displayPreview && (
                    <div>
                        <Segment style={{ marginBottom: 30 }}>
                            <div className="header blue headerStyleBlue">Table Preview</div>
                            <div className="meta" style={{ marginLeft: 10 }}>Preview the table</div>
                            <iframe src={iFrameSrc} height="600px" width="100%" frameBorder="2" />
                        </Segment>
                    </div>
                )}

            </div>
        );
    }
    else {
        return (
            <ErrorPage title="Access Denied" message=" Only Administrators, Records Managers or whitelisted users can view this page"/>
         )
    }
}

export default GridSettings;